import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/ip-days-of-supply", { params });
};

const getAllForCSV = params => {
  return restApiIP.get("/api/ip-days-of-supply/csv", { params });
};

const supplyInventoryService = {
  getAll,
  getAllForCSV
};

export default supplyInventoryService;